// extracted by mini-css-extract-plugin
export const copy = "homepage-copy-module--copy--q27DL";